export const RevisionedLineItemDialogs = {
  Fixed: 'fixed',
  Promotion: 'promotion',
} as const;

export type RevisionedLineItemDialogType =
  (typeof RevisionedLineItemDialogs)[keyof typeof RevisionedLineItemDialogs];
